<template>
  <section
    ref="section13"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="7"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
        <v-error-display :validation-errors="validationErrors"></v-error-display>
        <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3" v-if="showRenovations">
          <div><v-icon icon="build-circle" size="8"></v-icon></div>
          <div class="flex flex-col justify-center">
            <div class="mr-6 text-heading-3-desktop">
              Je bila vaša nepremičnina prenovljena?
            </div>
          </div>

          <v-lightbox is-authenticated footerless>
            <template v-slot:trigger>
                <div
                    class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                >
                    <v-icon icon="question-mark" size="4"></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <div class="flex items-start">
                    <v-icon
                        icon="question-mark"
                        class="mr-2.5"
                        size="4.5"
                    ></v-icon>
                    <div>
                        Dodatne informacije
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <p class="mb-[10px] text-icon-text-medium">
                    Prenova nepremičnine
                </p>
                <p class="mb-8 text-body-regular">
                    Vnesite ali je bila vaša nepremičnina v zadnjih časih (obdobje približno 5. letih) prenovljena ali ne. Pri vsaki možnosti prenov so tudi opisi, ki podrobneje razložijo pomen vsakega tipa prenove.
                </p>
            </template>
          </v-lightbox>
        </figure>
        <figure class="ml-auto mr-auto w-full max-w-3xl">
          <form method="POST" :action="routes.submitForm" id="select-property-renovations">
            <v-csrf-token></v-csrf-token>
            <figure>
              <figure class="mx-auto w-full max-w-lg" v-if="showRenovations">
                  <v-option-dropdown :options="isRenovatedOptions" name="renovation_status" label="Ali je obnovljena?" :default-value="isRenovatedDefaultValue" :on-change="onIsRenovatedChange"/>
              </figure>
              <figure v-if="showRenovations && renovated != null"
                class="mb-4 mt-8 flex w-full items-center justify-center gap-[10px] text-body-medium-button text-black-78"
              >
                <v-icon icon="house-work"></v-icon>
                <span> Trenutno stanje nepremičnine <sup>*</sup> </span>
              </figure>
              <figure class="mx-auto w-full max-w-lg" v-if="showRenovations && renovated !== null">
                  <v-option-dropdown v-if="renovated == 1" :options="renovatedYesOptions" name="zustand" label="Trenutno stanje" :default-value="status" :on-change="onRenovatedYesNoChange"/>
                  <v-option-dropdown v-if="renovated == 0" :options="renovatedNoOptions" name="zustand" label="Trenutno stanje" :default-value="status" :on-change="onRenovatedYesNoChange"/>
              </figure>
              <!--
              <figure v-if="showRenovations"
                class="ml-auto mr-auto grid w-full max-w-3xl grid-cols-2 grid-rows-1 gap-4 lg:flex lg:grid-cols-2 lg:flex-wrap lg:justify-center lg:gap-6"
              >
                <div
                  name="jeBilaVasaNepremicninaPrenovljenaDa"
                  :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.renovation_status ? 'has-errors' : '')]"
                >
                  <input
                    type="radio"
                    id="jeBilaVasaNepremicninaPrenovljenaDa"
                    name="renovation_status"
                    value="1"
                    class="hidden"
                    v-model="renovated"
                    @change="status = null"
                  />
                  <label
                    for="jeBilaVasaNepremicninaPrenovljenaDa"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="circle-check" size="5"></v-icon>
                    <span class="pointer-events-none select-none">Da</span>
                  </label>
                </div>
                <div
                  name="jeBilaVasaNepremicninaPrenovljenaNe"
                  :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]', (validationErrors.renovation_status ? 'has-errors' : '')]"
                >
                  <input
                    type="radio"
                    id="jeBilaVasaNepremicninaPrenovljenaNe"
                    name="renovation_status"
                    value="0"
                    class="hidden"
                    v-model="renovated"
                    @change="status = null"
                  />
                  <label
                    for="jeBilaVasaNepremicninaPrenovljenaNe"
                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                  >
                    <v-icon icon="cancel" size="5"></v-icon>
                    <span class="pointer-events-none select-none">Ne</span>
                  </label>
                </div>
              </figure>


              <figure v-if="showRenovations"
                class="ml-auto mr-auto grid w-full max-w-3xl grid-cols-1 gap-x-6 gap-y-[10px] lg:grid-cols-2 lg:gap-6"
              >
                <template v-if="renovated == 1">
                  <div
                    name="stanjeNepremicnine-delnaPrenova"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-delnaPrenova"
                      value="modernisiert"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-delnaPrenova"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="power-drill" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Delna prenova</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je prenovljena po delih npr. prebarvane stene,
                        nova kuhinja, itd.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-celostnaSanacija"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-celostnaSanacija"
                      value="saniert"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-celostnaSanacija"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="reset-wrench" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Celostna sanacija</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je bila v celoti sanirana / adaptirana.
                      </div>
                    </label>
                  </div>
                </template>
                <template v-if="renovated == 0">
                  <div
                    name="stanjeNepremicnine-prvaVselitev"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-prvaVselitev"
                      value="erstbezug_nach_sanierung"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-prvaVselitev"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="house-user" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Prva vselitev</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je na novo izgrajena ali popolnoma sanirana in
                        bo prvič vseljena.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-kotNova"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-kotNova"
                      value="neuwertig"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-kotNova"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="ambient-screen" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Kot nova</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je v brezihbnem stanju in ne potrebuje prenov
                        ali sanacij.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-dobroOhranjena"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-dobroOhranjena"
                      value="gepflegt"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-dobroOhranjena"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="bookmark-added" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Dobro ohranjena</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je dobro ohranjena in potrebuje zgolj manjše
                        sanacije.
                      </div>
                    </label>
                  </div>
                  <div
                    name="stanjeNepremicnine-potrebujePrenovo"
                    :class="['tile group relative w-full flex-col sm:flex-row', (validationErrors.zustand ? 'has-errors' : '')]"
                  >
                    <input
                      type="radio"
                      name="zustand"
                      id="stanjeNepremicnine-potrebujePrenovo"
                      value="renovierungsbeduerftig"
                      class="hidden"
                      v-model="status"
                    />

                    <label
                      for="stanjeNepremicnine-potrebujePrenovo"
                      class="flex cursor-pointer flex-col gap-[10px] rounded-xl bg-white p-4 px-8 py-11 py-6 text-body-medium-button text-black-78 shadow transition-all"
                    >
                      <div class="flex gap-3">
                        <v-icon icon="handyman" size="6"></v-icon>
                        <span
                          class="pointer-events-none select-none text-heading-4-medium"
                          >Potrebuje prenovo</span
                        >
                      </div>
                      <div class="text-body-regular text-black-40">
                        Nepremičnina je v slabem stanju in nujno potrebno prenovo.
                      </div>
                    </label>
                  </div>
                </template>
              </figure>
              -->
              <div class="relative py-10" v-if='showRenovations && renovated == true'>
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
              </div>
              <figure v-if="showRenovations && renovated == true"
                class="ml-auto mr-auto flex w-full max-w-lg gap-3 relative">
                    <div><v-icon icon="home-repair-service" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 mr-6 text-heading-3-desktop">
                            Kaj je bilo prenovljeno v nepremičnini?
                        </div>
                        <div class="text-body-regular text-black-40">
                            Vnesite podrobne podatke o prenovi nepremičnine.
                            Te podatki so zelo pomembni za izboljšanje vaše
                            ponujene cene.
                        </div>
                    </div>

                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 lg:-right-32 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Prenove na nepremičnini
                            </p>
                            <p class="mb-8 text-body-regular">
                                Tukaj vnesite podatke prenov vaše nepremičnine. Te podatki so pomembni za kupca ali najemnika, saj lahko samo tako približno ocenijo morebitne dodatne stroške. Pri letu zadnje prenove vnesite samo leto, kdaj je bilo na zadnje eno od opisanih del izvedeno. V kolikor nimate podatkov, pustite polja prazna.
                            </p>
                        </template>
                    </v-lightbox>
              </figure>
              <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-8 max-w-lg w-full mx-auto mt-11" v-if="showRenovations && renovated == true">
                    <li class="col-span-4">
                        <div
                            :class="[
                                'input group relative flex flex-col gap-[10px]',
                                validationErrors.last_renovation_year
                                    ? 'has-errors'
                                    : '',
                            ]"
                        >
                            <label
                                for="letoZadnjePrenove"
                                class="w-full text-body-medium-button"
                            >
                                <div class="label flex flex-col gap-[10px]">
                                    <div class="flex items-center gap-3">
                                        <v-icon
                                            icon="handyman"
                                            size="4"
                                        ></v-icon>
                                        <span>
                                            Leto zadnje prenove
                                            <sup>*</sup></span
                                        >
                                    </div>
                                </div>
                            </label>
                            <input
                                id="letoZadnjePrenove"
                                type="number"
                                name="last_renovation_year"
                                placeholder="Leto"
                                required
                                v-model="lastRenovationYear"
                            />
                        </div>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Prenova oken"
                            checkbox-position="right"
                            name="prenovaOken"
                            :checked="Boolean(windowsRenovationCasted)"
                            icon="window"
                            @vchanged="
                                windowsRenovation = !windowsRenovation
                            "
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_window
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Prenova strehe"
                            checkbox-position="right"
                            name="prenovaStrehe"
                            :checked="Boolean(roofRenovationCasted)"
                            icon="roofing"
                            @vchanged="roofRenovation = !roofRenovation"
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_floor
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Prenova tal"
                            checkbox-position="right"
                            name="prenovaTal"
                            :checked="Boolean(floorsRenovationCasted)"
                            icon="stairs"
                            @vchanged="floorsRenovation = !floorsRenovation"
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_roof
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Nove barve sten"
                            checkbox-position="right"
                            name="noveBarveSten"
                            :checked="Boolean(wallsRenovationCasted)"
                            icon="roller"
                            @vchanged="wallsRenovation = !wallsRenovation"
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_walls
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Prenova ogrevanja"
                            checkbox-position="right"
                            name="prenovaOgrevanja"
                            :checked="Boolean(heatingRenovationCasted)"
                            icon="water-heater"
                            @vchanged="
                                heatingRenovation = !heatingRenovation
                            "
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_heating
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Prenova vodne inštalacije"
                            checkbox-position="right"
                            name="prenovaVodneInstalacije"
                            :checked="Boolean(plumbingRenovationCasted)"
                            icon="faucet"
                            @vchanged="
                                plumbingRenovation = !plumbingRenovation
                            "
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_pipeing
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            label="Prenova električne instalacije"
                            checkbox-position="right"
                            name="prenovaElektricneInstalacije"
                            :checked="Boolean(electricalRenovationsCasted)"
                            icon="electric-meter"
                            @vchanged="
                                electricalRenovations =
                                    !electricalRenovations
                            "
                            :class="[
                                'checkbox group flex items-center',
                                validationErrors.renovation_electrical
                                    ? 'has-errors'
                                    : '',
                            ]"
                        ></v-checkbox>
                    </li>
              </ul>
              <div class="hidden-inputs">
                    <input
                        type="text"
                        name="renovation_window"
                        class="hidden"
                        v-model="windowsRenovationCasted"
                    />
                    <input
                        type="text"
                        name="renovation_floor"
                        class="hidden"
                        v-model="floorsRenovationCasted"
                    />
                    <input
                        type="text"
                        name="renovation_roof"
                        class="hidden"
                        v-model="roofRenovationCasted"
                    />
                    <input
                        type="text"
                        name="renovation_walls"
                        class="hidden"
                        v-model="wallsRenovationCasted"
                    />
                    <input
                        type="text"
                        name="renovation_heating"
                        class="hidden"
                        v-model="heatingRenovationCasted"
                    />
                    <input
                        type="text"
                        name="renovation_pipeing"
                        class="hidden"
                        v-model="plumbingRenovationCasted"
                    />
                    <input
                        type="text"
                        name="renovation_electrical"
                        class="hidden"
                        v-model="electricalRenovationsCasted"
                    />
              </div>
              <div class="relative py-10" v-if="showRenovations">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
              </div>
              <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3 relative">
                <div><v-icon icon="chair" size="8"></v-icon></div>
                <div class="flex flex-col justify-center">
                    <div class="mb-3 mr-6 text-heading-3-desktop">
                    Kako je opremljena vaša nepremičnina?
                    </div>
                    <div class="text-body-regular text-black-40">
                    Izberete lahko samo eno možnost.
                    </div>
                </div>

                <v-lightbox is-authenticated footerless>
                    <template v-slot:trigger>
                        <div
                            class="absolute right-0 lg:-right-32 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                        >
                            <v-icon icon="question-mark" size="4"></v-icon>
                        </div>
                    </template>
                    <template v-slot:head>
                        <div class="flex items-start">
                            <v-icon
                                icon="question-mark"
                                class="mr-2.5"
                                size="4.5"
                            ></v-icon>
                            <div>
                                Dodatne informacije
                            </div>
                        </div>
                    </template>
                    <template v-slot:content>
                        <p class="mb-[10px] text-icon-text-medium">
                            Opremljenost nepremičnine
                        </p>
                        <p class="text-body-regular">
                            Med možnostmi izberite, ali je vaša nepremičnina:
                        </p>
                        <ul class="mb-8 text-body-regular list-disc pl-6">
                        <li>
                            neopremljena (stanovanje nima pohištva)
                        </li>
                        <li>
                            delno opremljena (stanovanje ima le del pohištva, vendar bo kupec potreboval dokupiti pohištvo za celostno opremljeno nepremičnino)
                        </li>
                        <li>
                            opremljeno (stanovanje je polno opremljeno in primerno za takojšnje bivanje)
                        </li>
                        </ul>

                        <p class="mb-[10px] text-icon-text-medium">
                            Delno opremljeno ali opremljeno
                        </p>
                        <p class="mb-4 text-body-regular">
                            Če izberete "delno opremljeno" ali "opremljeno", vas prosimo, da kasneje pri opish nepremičnine v prostem besedilu opišete, kako je stanovanje opremljeno, katero pohištvo je v nepremičnini in v kakšnem stanju je. Tako zainteresirana stranka dobi boljši pregled, kaj bi še potrebovala.
                        </p>
                    </template>
                </v-lightbox>
              </figure>
              <figure
                class="mx-auto w-full max-w-lg mt-11"
                >
                <v-option-dropdown :options="estateEquipmentOptions" name="ind_2028_Feld_ObjAusstattung39" label="Opremljenost" :default-value="stepData.ind_2028_Feld_ObjAusstattung39" :on-change="onEstateEquipmentChange"/>
                <!--
                <div
                    name="neOpremljeno"
                    :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[254px]', (validationErrors.ind_2028_Feld_ObjAusstattung39 ? 'has-errors' : '')]"
                >
                    <input
                    type="radio"
                    name="ind_2028_Feld_ObjAusstattung39"
                    id="kakoJeOpremljenaVasaNepremicnina-neopremljeno"
                    value="ind_Schl_3131"
                    class="hidden"
                    v-model="estateEquipment"
                    />

                    <label
                    for="kakoJeOpremljenaVasaNepremicnina-neopremljeno"
                    class="flex min-h-[144px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all lg:min-h-[254px]"
                    >
                    <img
                        :src="$assetsUrl +'/images/neopremljeno.webp'"
                        alt="Neopremljeno"
                        class="pointer-events-none mb-4 min-h-[90px] w-[90px] select-none transition-all lg:w-32"
                    />

                    <span class="pointer-events-none select-none">Neopremljeno</span>
                    </label>
                </div>
                <div
                    name="delnoOpremljeno"
                    :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[254px]', (validationErrors.ind_2028_Feld_ObjAusstattung39 ? 'has-errors' : '')]"
                >
                    <input
                    type="radio"
                    name="ind_2028_Feld_ObjAusstattung39"
                    id="kakoJeOpremljenaVasaNepremicnina-desnoOpremljeno"
                    value="ind_Schl_3133"
                    class="hidden"
                    v-model="estateEquipment"
                    />

                    <label
                    for="kakoJeOpremljenaVasaNepremicnina-desnoOpremljeno"
                    class="flex min-h-[144px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all lg:min-h-[254px]"
                    >
                    <img
                        :src="$assetsUrl +'/images/delno-opremljeno.webp'"
                        alt="Delno opremljeno"
                        class="pointer-events-none mb-4 min-h-[90px] w-[90px] select-none transition-all lg:w-32"
                    />

                    <span class="pointer-events-none select-none"
                        >Delno opremljeno</span
                    >
                    </label>
                </div>
                <div
                    name="opremljeno"
                    :class="['tile group relative w-full flex-col sm:flex-row lg:max-w-[254px]', (validationErrors.ind_2028_Feld_ObjAusstattung39 ? 'has-errors' : '')]"
                >
                    <input
                    type="radio"
                    name="ind_2028_Feld_ObjAusstattung39"
                    id="kakoJeOpremljenaVasaNepremicnina-opremljeno"
                    value="ind_Schl_3135"
                    class="hidden"
                    v-model="estateEquipment"
                    />

                    <label
                    for="kakoJeOpremljenaVasaNepremicnina-opremljeno"
                    class="flex min-h-[144px] cursor-pointer flex-col items-center justify-center rounded-3xl bg-white p-4 text-sm font-medium text-gray-900 shadow transition-all lg:min-h-[254px]"
                    >
                    <img
                        :src="$assetsUrl +'/images/opremljeno.webp'"
                        alt="Opremljeno"
                        class="pointer-events-none mb-4 min-h-[90px] w-[90px] select-none transition-all lg:w-32"
                    />

                    <span class="pointer-events-none select-none">Opremljeno</span>
                    </label>
                </div>
                -->
              </figure>
              <div class="relative py-10">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
              </div>
              <figure class="flex max-w-lg flex-col gap-11 lg:w-full mx-auto">
                    <figure class="flex gap-3 relative">
                        <div>
                            <v-icon icon="contract-edit" size="8"></v-icon>
                        </div>
                        <div class="flex flex-col justify-center">
                            <div class="mb-3 text-heading-3-desktop">
                                Dodatni podatki
                            </div>
                            <div class="text-body-regular text-black-40">
                                Izberete lahko več možnosti.
                            </div>
                        </div>
                        <v-lightbox is-authenticated footerless>
                            <template v-slot:trigger>
                                <div
                                    class="absolute right-0 lg:-right-32 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                                >
                                    <v-icon icon="question-mark" size="4"></v-icon>
                                </div>
                            </template>
                            <template v-slot:head>
                                <div class="flex items-start">
                                    <v-icon
                                        icon="question-mark"
                                        class="mr-2.5"
                                        size="4.5"
                                    ></v-icon>
                                    <div>
                                        Dodatne informacije
                                    </div>
                                </div>
                            </template>
                            <template v-slot:content>
                                <p class="mb-[10px] text-icon-text-medium">
                                    Spomeniško varstvo
                                </p>
                                <p class="mb-4 text-body-regular">
                                    Preverite, če imate potrejeno spomeniško varstvo
                                    na vašem objektu. V primeru, da je nepremičnina
                                    spomeniško zaščitena, odkljukajte to možnost.
                                </p>
                                <p class="text-body-regular">
                                    Objekti pod spomeniškim varstvom so običajno
                                    zaradi njihove starosti ali državne ali
                                    mednarodne kulturne pomembnosti, zaščiteni.
                                    Prenove ali kakršnekoli spremembe na tako
                                    imenovanih objektih se mora ob morajo uskladiti
                                    s pravnimi organi.
                                </p>
                            </template>
                        </v-lightbox>
                    </figure>
                    <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4">
                        <li
                            class="col-span-4"
                            v-for="(
                                extra, onOfficeEnum
                            ) in stepData.extra_data_options"
                            :key="'extra-' + onOfficeEnum"
                        >
                            <v-checkbox
                                :id="onOfficeEnum"
                                :name="'extra_data[' + onOfficeEnum + ']'"
                                :label="stepData.labels[onOfficeEnum].label"
                                checkbox-position="right"
                                :value="onOfficeEnum"
                                :icon="extra.icon"
                                :checked="
                                    stepData.extra_data != null &&
                                    stepData.extra_data[onOfficeEnum]
                                "
                            ></v-checkbox>
                        </li>
                        <li class="col-span-4">
                            <v-checkbox
                                name="aliNepremicninaSpadaPodSpomeniskoVarstvo"
                                label="Ali nepremičnina spada pod spomeniško varstvo"
                                checkbox-position="right"
                                icon="shield"
                                @vchanged="isMonument = !isMonument"
                                :checked="Boolean(isMonumentCasted)"
                            ></v-checkbox>
                        </li>
                    </ul>
                    <input
                        type="hidden"
                        name="denkmalgeschuetzt"
                        v-model="isMonumentCasted"
                    />
                    <div>
                        <figure
                            v-if="stepData.showpets"
                            class="mb-4 flex w-full items-center gap-[10px] text-body-medium-button text-black-78 lg:justify-center"
                        >
                            <v-icon icon="pets" size="4"></v-icon>
                            <span class="">
                                Ali so hišni ljubljenčki dovoljeni? <sup>*</sup>
                            </span>
                        </figure>
                        <figure
                            v-if="stepData.showpets"
                            class="grid grid-cols-1 grid-rows-1 gap-4 lg:grid-cols-3 lg:justify-center lg:gap-6"
                        >
                            <div
                                name="aliSohisniLjubljenckiDovoljeni-da"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.haustiere
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="haustiere"
                                    id="aliSohisniLjubljenckiDovoljeni-da"
                                    value="1"
                                    class="hidden"
                                    v-model="allowsPets"
                                />

                                <label
                                    for="aliSohisniLjubljenckiDovoljeni-da"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon
                                        icon="circle-check"
                                        size="5"
                                    ></v-icon>
                                    <span
                                        class="pointer-events-none select-none"
                                        >Da</span
                                    >
                                </label>
                            </div>
                            <div
                                name="aliSohisniLjubljenckiDovoljeni-ne"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.haustiere
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="haustiere"
                                    id="aliSohisniLjubljenckiDovoljeni-ne"
                                    value="0"
                                    class="hidden"
                                    v-model="allowsPets"
                                />

                                <label
                                    for="aliSohisniLjubljenckiDovoljeni-ne"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon icon="cancel" size="5"></v-icon>

                                    <span
                                        class="pointer-events-none select-none"
                                        >Ne</span
                                    >
                                </label>
                            </div>
                            <div
                                name="aliSohisniLjubljenckiDovoljeni-poDogovoru"
                                :class="[
                                    'tile group relative w-full flex-col sm:flex-row lg:max-w-[171px]',
                                    validationErrors.haustiere
                                        ? 'has-errors'
                                        : '',
                                ]"
                            >
                                <input
                                    type="radio"
                                    name="haustiere"
                                    id="aliSohisniLjubljenckiDovoljeni-poDogovoru"
                                    value="2"
                                    class="hidden"
                                    v-model="allowsPets"
                                />

                                <label
                                    for="aliSohisniLjubljenckiDovoljeni-poDogovoru"
                                    class="flex cursor-pointer items-center justify-center gap-[10px] rounded-3xl bg-white p-4 py-6 text-body-medium-button text-black-78 shadow transition-all"
                                >
                                    <v-icon icon="voice" size="5"></v-icon>

                                    <span
                                        class="pointer-events-none select-none"
                                        >Po dogovoru</span
                                    >
                                </label>
                            </div>
                        </figure>
                    </div>
              </figure>
              <div class="relative py-10">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-200"></div>
                </div>
              </div>
              <figure class="flex gap-3 max-w-lg lg:w-full mx-auto">
                    <div><v-icon icon="car" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Parkirna mesta
                        </div>
                        <div class="text-body-regular text-black-40">
                            Označite katere vrste parkirnih mest ima
                            nepremičnina in vnesite število parkirnih mest.
                            Lahko izberete več možnosti.
                        </div>
                    </div>
              </figure>
              <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4 mt-11 max-w-lg mx-auto">
                    <li
                        class="col-span-4"
                        v-for="(
                            garage, onOfficeEnum
                        ) in stepData.stellplatzart_options"
                        :key="'garage-' + onOfficeEnum"
                    >
                        <v-checkbox
                            :id="onOfficeEnum"
                            class="text-small-text-medium text-black-78"
                            :label="
                                stepData.labels.stellplatzart.values[
                                    onOfficeEnum
                                ]
                            "
                            checkbox-position="right"
                            :name="'stellplatzart[' + onOfficeEnum + ']'"
                            :value="onOfficeEnum"
                            :icon="garage.icon"
                            :checked="
                                stepData.stellplatzart != null &&
                                stepData.stellplatzart[onOfficeEnum]
                            "
                        ></v-checkbox>
                    </li>
              </ul>
            </figure>
          </form>
        </figure>
      </figure>
    </main>
    <v-add-listing-foot>
        <a
            :href="routes.previousStep ? routes.previousStep : '/'"
            class="button button--white button--md h-[48px] w-[240px] px-6 mr-4"
        >
            <v-icon icon="arrow-right" class="rotate-180" size="4"></v-icon>
            <label class="text-small-text-medium">Nazaj</label>
        </a>
      <a
        @click="submitForm('select-property-renovations')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';
import OptionDropdown from '../OptionDropdown.vue';
import ErrorDisplay from '../ErrorDisplay.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
    "v-option-dropdown": OptionDropdown,
    "v-error-display": ErrorDisplay
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
        objektart: null,
        renovated: null,
        status: null,
        lastRenovationYear: null,
        windowsRenovation: null,
        floorsRenovation: null,
        roofRenovation: null,
        wallsRenovation: null,
        heatingRenovation: null,
        plumbingRenovation: null,
        electricalRenovations: null,
        estateEquipment: null,
        isMonument: null,
        allowsPets: null,
    };
  },
  mounted() {
    this.objektart = this.stepData.objektart;
    this.renovated = (this.old.renovation_status ? this.old.renovation_status : (this.stepData.renovation_status != null ? Number(this.stepData.renovation_status) : null))
    this.status = (this.old.zustand ? this.old.zustand : this.stepData.zustand);
    this.lastRenovationYear = this.old.last_renovation_year ? this.old.last_renovation_year : this.stepData.last_renovation_year;
    this.windowsRenovation = this.old.renovation_window ? this.old.renovation_window : this.stepData.renovation_window;
    this.floorsRenovation = this.old.renovation_floor ? this.old.renovation_floor : this.stepData.renovation_floor;
    this.roofRenovation = this.old.renovation_roof ? this.old.renovation_roof : this.stepData.renovation_roof;
    this.wallsRenovation = this.old.renovation_walls ? this.old.renovation_walls : this.stepData.renovation_walls;
    this.heatingRenovation = this.old.heatingRenovation ? this.old.heatingRenovation : this.stepData.renovation_heating;
    this.plumbingRenovation = this.old.plumbingRenovation ? this.old.plumbingRenovation : this.stepData.renovation_pipeing;
    this.electricalRenovations = this.old.electricalRenovations ? this.old.electricalRenovations : this.stepData.renovation_electrical;
    this.estateEquipment = this.old.estateEquipment ? this.old.estateEquipment : this.stepData.ind_2028_Feld_ObjAusstattung39
    this.isMonument = this.old.denkmalgeschuetzt ? this.old.denkmalgeschuetzt : this.stepData.denkmalgeschuetzt;
    this.allowsPets = this.old.haustiere ? this.old.haustiere : this.stepData.haustiere;
  },
  computed: {
    isRenovatedDefaultValue() {
        return (this.old.renovation_status ? this.old.renovation_status : (this.stepData.renovation_status != null ? Number(this.stepData.renovation_status) : null));
    },
    isRenovatedOptions() {
        return [
            {label: 'Da', value: 1},
            {label: 'Ne', value: 0},
        ]
    },
    renovatedYesOptions() {
        return [
            {label: 'Delna prenova', value: 'modernisiert'},
            {label: 'Celostna sanacija', value: 'saniert'},
        ];
    },
    renovatedNoOptions() {
        return [
            {label: 'Prva vselitev', value: 'erstbezug_nach_sanierung'},
            {label: 'Kot nova', value: 'neuwertig'},
            {label: 'Dobro ohranjena', value: 'gepflegt'},
            {label: 'Potrebuje prenovo', value: 'renovierungsbeduerftig'},
        ];
    },
    estateEquipmentOptions() {
        return [
            {label: 'Neopremljeno', value: 'ind_Schl_3131'},
            {label: 'Delno opremljeno', value: 'ind_Schl_3133'},
            {label: 'Opremljeno', value: 'ind_Schl_3135'}
        ]
    },
    renovatedCasted() {
      return this.renovated ? 1 : 0;
    },
    windowsRenovationCasted() {
        return this.windowsRenovation ? 1 : 0;
    },
    floorsRenovationCasted() {
        return this.floorsRenovation ? 1 : 0;
    },
    roofRenovationCasted() {
        return this.roofRenovation ? 1 : 0;
    },
    wallsRenovationCasted() {
        return this.wallsRenovation ? 1 : 0;
    },
    heatingRenovationCasted() {
        return this.heatingRenovation ? 1 : 0;
    },
    plumbingRenovationCasted() {
        return this.plumbingRenovation ? 1 : 0;
    },
    electricalRenovationsCasted() {
        return this.electricalRenovations ? 1 : 0;
    },
    isMonumentCasted() {
        return this.isMonument ? 1 : 0;
    },
    showRenovations() {
        return !(["ind_Schl_3259", "hausbau", "grundstueck"].includes(this.objektart));
    },
    validated() {
        if (this.showRenovations) {
            if(this.renovated === null || this.status == null) {
                return false;
            }

            if(this.renovated == 1 && (this.lastRenovationYear == null || this.lastRenovationYear == '')) {
                return false;
            }
        }

        if(!this.estateEquipment) {
            return false;
        }

        if (
            this.stepData.vermarktungsart == "miete" &&
            this.stepData.showpets &&
            this.allowsPets === null
        ) {
            return false;
        }

        return true;
    }
  },
  methods: {
    onIsRenovatedChange(newValue) {
        if (this.renovated !== newValue) {
            this.renovated = newValue;
            this.status = null;
        }

        if (!this.renovated) {
            this.lastRenovationYear = null;
            this.windowsRenovation = null;
            this.floorsRenovation = null;
            this.roofRenovation = null;
            this.wallsRenovation = null;
            this.heatingRenovation = null;
            this.plumbingRenovation = null;
            this.electricalRenovations = null;
        }
    },
    onRenovatedYesNoChange(newValue) {
        this.status = newValue;
    },
    onEstateEquipmentChange(newValue) {
        this.estateEquipment = newValue;
    },
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
};
</script>
